import { type Platform, PlatformEnum } from "~/types/platform";

export const appendTickerToPolymarketLink = (
  baseLink: string,
  platform: Platform,
  ticker?: string
): string => {
  if (!baseLink) return baseLink;

  if (platform !== PlatformEnum.POLYMARKET || !ticker) {
    return baseLink;
  }

  try {
    const url = new URL(baseLink);
    const normalizedPathname = url.pathname.endsWith("/")
      ? url.pathname.slice(0, -1)
      : url.pathname;

    url.pathname = `${normalizedPathname}/${ticker}`;

    return url.toString();
  } catch {
    return baseLink;
  }
};
